import { useMemo } from 'react';

import type { GetSurveyResultResponse } from '@genially/contracts';

import { useSidebarSummaryWithContentContext } from '../../../SidebarSummaryWithContent.context';

export const useSurveySidebarData = () => {
  const {
    summary: { data },
  } = useSidebarSummaryWithContentContext();

  const fetchedData = data as GetSurveyResultResponse;

  const totalData = useMemo(() => {
    return fetchedData.reduce((acc, item) => acc + item.totalAnswers, 0);
  }, [fetchedData]);

  return {
    aggregatedData: fetchedData,
    totalData,
  };
};
